import { render, staticRenderFns } from "./HolidayTabComponent.vue?vue&type=template&id=11620722&scoped=true&"
import script from "./HolidayTabComponent.vue?vue&type=script&lang=js&"
export * from "./HolidayTabComponent.vue?vue&type=script&lang=js&"
import style0 from "./HolidayTabComponent.vue?vue&type=style&index=0&id=11620722&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11620722",
  null
  
)

export default component.exports